module.exports = __webpack_public_path__ + "static/img/YD200.36b4ece.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YD200.png
// module id = rA9L
// module chunks = 2